import { render, staticRenderFns } from "./supplier-edit.vue?vue&type=template&id=0f598764&scoped=true&"
import script from "./supplier-edit.vue?vue&type=script&lang=ts&"
export * from "./supplier-edit.vue?vue&type=script&lang=ts&"
import style0 from "./supplier-edit.vue?vue&type=style&index=0&id=0f598764&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f598764",
  null
  
)

export default component.exports